import React from 'react';
import './PersonalInfo.css';

const PersonalInfo = ({ formData, handleInputChange }) => {
  return (
    <div className="col-sm-12 col-lg-3">
      <fieldset>
        <legend>Personal Information</legend>
        <div className="floating-label-wrap">
          <label htmlFor="firstName" className="floating-label">
            First Name<span className="mandatory">*</span>
          </label>
          <input
            id="first_name"
            name="first_name"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.first_name}
            onChange={handleInputChange}
            maxLength={50}
          />
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="lastName" className="floating-label">
            Last Name<span className="mandatory">*</span>
          </label>
          <input
            id="last_name"
            name="last_name"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.last_name}
            onChange={handleInputChange}
            maxLength={50}
          />
        </div>

        <div className="floating-label-wrap">
          <label htmlFor="homePhone" className="floating-label">
            Home Phone
          </label>
          <input
            id="home_phone"
            name="home_phone"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.home_phone}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              // Allow only digits and navigation keys
              if (
                !/[0-9]/.test(e.key) && // block non-digits
                !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              // Prevent pasting non-digit content
              const pastedData = e.clipboardData.getData('Text');
              if (!/^\d+$/.test(pastedData)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
          />
        </div>

        {/* <input
          id="home_phone"
          name="home_phone"
          className="longBox floating-label-field floating-label-field--s3"
          type="text"
          value={formData.home_phone}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            // Allow only digits and navigation keys
            if (
              !/[0-9]/.test(e.key) && // block non-digits
              !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
            ) {
              e.preventDefault();
            }
          }}
          onPaste={(e) => {
            // Prevent pasting non-digit content
            const pastedData = e.clipboardData.getData('Text');
            if (!/^\d+$/.test(pastedData)) {
              e.preventDefault();
            }
          }}
          maxLength={10}
        /> */}

        <div className="floating-label-wrap">
          <label htmlFor="cellPhone" className="floating-label">
            Cell Phone
          </label>
          <input
            id="cell_phone"
            name="cell_phone"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.cell_phone}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData('Text');
              if (!/^\d+$/.test(pastedData)) {
                e.preventDefault();
              }
            }}
            maxLength={10}
          />
        </div>
        <div className="styled-input">
          <label htmlFor="preferredPhone" className="anchor">
            Preferred Phone
          </label>
          <select
            id="preferred_phone"
            name="preferred_phone"
            className="preferredPhone"
            value={formData.preferred_phone}
            onChange={handleInputChange}
          >
            <option value="" disabled>Please Select</option>
            <option value="1">Home Phone</option>
            <option value="2">Cell Phone</option>
          </select>
        </div>
        <div className="sex-plays-grid">
          <div className="sex-plays-row">
            <span className="sex-plays-label">Sex</span>
            <div className="sex-plays-options">
              <label className="sex-plays-option" htmlFor="male">
                <input
                  id="male"
                  name="male"
                  type="radio"
                  value="1"
                  checked={formData.male === true || formData.male === 1}
                  onChange={() => handleInputChange({ target: { name: 'male', value: 1 } })}
                />
                <span className="sex-plays-option-text">Male</span>
              </label>
              <label className="sex-plays-option" htmlFor="female">
                <input
                  id="female"
                  name="male"
                  type="radio"
                  value="0"
                  checked={formData.male === false || formData.male === 0}
                  onChange={() => handleInputChange({ target: { name: 'male', value: 0 } })}
                />
                <span className="sex-plays-option-text">Female</span>
              </label>
            </div>
          </div>

          <div className="sex-plays-row">
            <span className="sex-plays-label">Plays</span>
            <div className="sex-plays-options">
              <label className="sex-plays-option" htmlFor="plays-right">
                <input
                  id="plays-right"
                  name="plays"
                  type="radio"
                  value="Right Handed"
                  checked={formData.plays === 'Right Handed'}
                  onChange={handleInputChange}
                />
                <span className="sex-plays-option-text">Right Handed</span>
              </label>
              <label className="sex-plays-option" htmlFor="plays-left">
                <input
                  id="plays-left"
                  name="plays"
                  type="radio"
                  value="Left Handed"
                  checked={formData.plays === 'Left Handed'}
                  onChange={handleInputChange}
                />
                <span className="sex-plays-option-text">Left Handed</span>
              </label>
            </div>
          </div>
        </div>


        <div className="floating-label-wrap floating-checkbox">
          <label className="anchor1">
            Playing Preference (check all that apply)
            <span className="mandatory">*</span>
          </label>
          <ul className="">
            {[
              { display: "Singles", apiValue: "Single" },
              { display: "Doubles", apiValue: "Doubles" },
              { display: "Mixed Doubles", apiValue: "Mixed Doubles" }
            ].map((item) => (
              <li key={item.display}>
                <input
                  id={item.display}
                  name="playing_preference"
                  type="checkbox"
                  value={item.apiValue}
                  checked={formData.playing_preference ? formData.playing_preference.split(",").map(pref => pref.trim()).includes(item.apiValue) : false}
                  onChange={(e) => {
                    const apiValue = e.target.value;
                    let newPreferences = formData.playing_preference ? formData.playing_preference.split(",").map(pref => pref.trim()) : [];

                    if (newPreferences.includes(apiValue)) {
                      newPreferences = newPreferences.filter((pref) => pref !== apiValue);
                    } else {
                      newPreferences.push(apiValue);
                    }

                    handleInputChange({ target: { name: "playing_preference", value: newPreferences.join(",") } });
                  }}
                />
                <label className="checkboxlabel">{item.display}</label>
              </li>
            ))}
          </ul>
        </div>


        <div className="styled-input">
          <label>Open To Challenges</label>


          <select
            id="opentochallenges"
            name="opentochallenges"
            className="opentochallenges"
            value={formData.opentochallenges}
            onChange={handleInputChange}
          >
            <option value="" disabled>Please Select</option>
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>

        </div>


        <div className="styled-input mt-2">
          <label>Same Gender Only</label>
          <select
            id="playwithonlysamegender"
            name="playwithonlysamegender"
            className="playwithonlysamegender"
            value={formData.playwithonlysamegender}
            onChange={handleInputChange}
          >
            <option value="" disabled>Please Select</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>




        {formData.opentochallenges === "1" && (
          <div className="radio-section">
            <label htmlFor="opponent_skilllevel my-3">
              Opponent Skill Level <span className="mandatory">*</span>
            </label>
            <ul>
              <li>
                <input
                  id="opponentSkillLevel1"
                  name="opponent_skilllevel"
                  type="radio"
                  value="onlyMyRating"
                  checked={formData.opponent_skilllevel === "onlyMyRating"}
                  onChange={handleInputChange}
                />
                <label className="radiolabel" htmlFor="userForm.skillLevel1"> Only My Rating
                </label>
              </li>
              <li>
                <input
                  id="opponentSkillLevel2"
                  name="opponent_skilllevel"
                  type="radio"
                  value="within0.5Rating"
                  checked={formData.opponent_skilllevel === "within0.5Rating"}
                  onChange={handleInputChange}
                />
                <label className="radiolabel" htmlFor="userForm.skillLevel2"> Within 0.5 rating
                </label>
              </li>
              <li>
                <input
                  id="opponentSkillLevel3"
                  name="opponent_skilllevel"
                  type="radio"
                  value="anyRating"
                  checked={formData.opponent_skilllevel === "anyRating"}
                  onChange={handleInputChange}
                />
                <label className="radiolabel" htmlFor="userForm.skillLevel3"> Any Rating
                </label>
              </li>
              <li>
                <input
                  id="opponentSkillLevel4"
                  name="opponent_skilllevel"
                  type="radio"
                  value="onlyPlayUp"
                  checked={formData.opponent_skilllevel === "onlyPlayUp"}
                  onChange={handleInputChange}
                />
                <label className="radiolabel" htmlFor="userForm.skillLevel4"> Only Play Up
                </label>
              </li>
            </ul>
          </div>
        )}



        <div style={{ clear: "both" }} />
      </fieldset>
    </div>
  )
}

export default PersonalInfo